export default __webpack_public_path__ + "static/media/trr-drink-juice-hydration.50deb312.png";